<template>
  <div>
    <header-component></header-component>
    <div
      class="g-bg-img-hero"
      style="
        background-image: url('../../../static/assets/include/svg/svg-bg1.svg');
        background-attachment: fixed;
      "
    >
      <div class="container registation_content g-pt-50 g-pb-50">
        <div class="row">
          <div class="g-max-width-645 text-center mx-auto g-mb-0">
            <h2 class="h2 mb-3">Changing Life through Lenses® {{ new Date().getFullYear() }}</h2>
          </div>
          <div
            class="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12 col-xs-12"
          >
            <div class="row">
              <div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 g-pb-20">
                <p>
                 While you may experience ongoing effects
                  of the pandemic, we want to ensure you have the resources to
                  support the vision care of your whole community. Essilor
                  Vision Foundation and Changing Life through Lenses (CLTL)
                  stands as your partner to help you maintain and increase your
                  charitable work to provide glasses to those most in need.
                </p>
              </div>
            </div>
            <!--
   <ul>
        <li>
          You can enter the doctor’s email address on the My Account page or when adding a new doctor on the Order page
        </li>
        <li>
          After the deadline, you will not be able to submit an order without having an email address  for the prescribing doctor
        </li>
    </ul>
 -->
            <h4>Forecast Update</h4>
            <p>
              Please update your pledge/forecast for {{ new Date().getFullYear() }}. We understand it may
              be difficult to predict how many you will serve. Please provide a
              conservative estimate of how many charitable orders you anticipate
              placing this year. Remember, you can change your forecast number
              at any time on the My Account page.
            </p>
            <div class="row">
              <pledge
                :Account="Account"
                :PledgeLabel="pledge"
                :PledgeHelpText="pledgeHelpText"
                :FormInputs="FormInputs"
                :OfficeLocationValidationResult="OfficeLocationValidationResult"
              ></pledge>
            </div>
            <br />
            <br />
            <h4>End of Year Recap</h4>
            <p>Please complete the following questions:</p>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group g-mb-0">
                  <h5>
                    How do you plan on serving those patients?
                    <!-- <span><i class="fa fa-question-circle-o"></i></span> -->
                  </h5>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    value="Serve walk ins and sporadic referrals in my office"
                    v-model="forecastServices"
                    type="checkbox"
                  />
                  Serve walk ins and sporadic referrals in my office
                  <br/>
                  <input
                    class="form-check-input"
                    value="Host a vision event(s)"
                    v-model="forecastServices"
                    type="checkbox"
                  />
                  Host a vision event(s)
                  <br/>
                  <input
                    class="form-check-input"
                    value="Partner with a local non profit or school to receive their referrals in my office"
                    v-model="forecastServices"
                    type="checkbox"
                  />
                  Partner with a local non profit or school to receive their referrals in my office
                  <br/>
                  <input
                    class="form-check-input"
                    value="Volunteer at local clinics, health fairs, or vision events"
                    v-model="forecastServices"
                    type="checkbox"
                  />
                  Volunteer at local clinics, health fairs, or vision events
                  <br/>
                  <input
                    class="form-check-input"
                    value="I’m not sure"
                    v-model="forecastServices"
                    type="checkbox"
                  />
                    I’m not sure
                </div>
              </div>
            </div>

            <br />
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group g-mb-0">
                  <h5>
                    {{ q1 }}
                    <!-- <span><i class="fa fa-question-circle-o"></i></span> -->
                  </h5>
                  <p>
                    (Things to consider: Where, who, and when you served, did
                    you find giving back had a positive impact for you or your
                    organization)
                  </p>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group" v-show="1">
                  <input
                    v-bind:class="{ error_field: false }"
                    type="text"
                    minlength="3"
                    maxlength="1000"
                    v-model="Account.UseCase"
                    class="form-control no-arrow-updown"
                  />
                  <!-- <p class="error-message" v-if="1">{{ _ }}</p>  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group g-mb-0">
                  <h5>
                    {{ q2 }}
                    <!-- <span><i class="fa fa-question-circle-o"></i></span> -->
                  </h5>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group" v-show="1">
                  <input
                    v-bind:class="{ error_field: false }"
                    type="text"
                    minlength="3"
                    maxlength="1000"
                    v-model="Account.FeedBack"
                    class="form-control no-arrow-updown"
                  />
                  <!-- <p class="error-message" v-if="1">{{ _ }}</p> -->
                </div>
              </div>
            </div>
            <!--EPE-327 Update Contact Volunteer -->
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div class="form-group g-mb-0">
                  <h5>Update your Volunteer Engagement</h5>
                </div>
                <div>
                  <p>Thank you for being a part of Changing Life through Lenses' (CLTL) extraordinary community of charitable eye doctors, practices and non-profits. Occasionally, we may become aware of volunteer opportunities available in your area, such as:</p>
                  <ul>
                    <li>Volunteering at a regional clinic to conduct vision exams</li>
                    <li>Connecting with a local nonprofit or school requesting vision services</li>
                    <li>Supporting an individual patient inquiring with us about vision services in your area</li>
                  </ul>
                </div>
                <div class="form-check">
                  <div>
                    <input class="form-check-input" type="checkbox" v-model="toBeContactedAsVolunteer" checked><!--v-model="AccountEdit.toBeContactedAsVolunteer"-->
                    <span class="account_p">I would like to be contacted if there are volunteer opportunities in my area.</span>
                  </div>
                </div>
              </div>
            </div>

            <br />

            <p>
              Thank you for all your hard work and for everything you do to help
              those in need in your community!
            </p>
            <p>Together, we can keep Changing Life through Lenses.</p>

            <br />

            <div class="row">
              <div class="col-md-12 col-lg-12 col-xs-12 col-sm-12 text-center">
                <button
                  @click="SubmitForecast()"
                  v-bind:disabled="
                    !(
                      Account.PrimaryContact.OfficeLocation.NumberOfJobs > -1 &&
                      (Account.UseCase.trim() != '' ? true : false)
                    )
                  "
                  type="button"
                  class="btn g-color-white u-btn-primary g-rounded-10 g-font-size-18"
                >
                  Submit
                </button>
              </div>
            </div>
            <!--<help-form v-if="showHelpForm" @closeWufoo="ToggleHelpForm" :Account="Account"></help-form>-->
          </div>
        </div>
      </div>
    </div>
    <annual-forecasting-modal
      v-if="showForecastingModal"
    ></annual-forecasting-modal>
    <loading-component v-if="!isLoadFinish"></loading-component>
    <footer-component></footer-component>
  </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import LoadingComponent from "@/components/shared/LoadingComponent";
import HelpForm from "@/components/shared/HelpForm";
import AnnualForecastingModal from "@/components/portal/AnnualForecastingModal";
import Pledge from "../registration/Pledge";
export default {
  components: {
    Pledge,
    HeaderComponent,
    FooterComponent,
    LoadingComponent,
    HelpForm,
    AnnualForecastingModal,
  },
  data() {
    return {
      // isUseCaseFilled : false,
      Account: {
        SalesforceId: null,
        EmailAddress: null,
        Password: null,
        AccountType: null,
        FeedBack: null,
        UseCase: "",
        toBeContactedAsVolunteer: null,
        PrimaryContact: {
          LegalName: null,
          OfficeLocation: {
            NumberOfJobs: null,
            Jobs: {
              January: null,
              February: null,
              March: null,
              April: null,
              May: null,
              June: null,
              July: null,
              August: null,
              September: null,
              October: null,
              November: null,
              December: null,
            },
          },
        },
      },
      q1: "How did you use CLTL last year?*",
      q2:
        "Do you have any other feedback, comments, or thoughts you would like to share about Changing Life through Lenses?",
      pledge:
        "The participant pledges to place the following number of charitable orders this calendar year.*",
      pledgeHelpText:
        "Please provide a best estimate. You can modify your estimate on the My Account page any time.",
      isLoadFinish: true,
      showForecastingModal: false,
      FormInputs: null,
      OfficeLocationValidationResult: {
        OfficeLocationZip: null,
      },
      forecastServices: [],
      // AccountView: {},
      // AccountEdit: {},
      toBeContactedAsVolunteer: true,
    };
  },
  // computed: {
  //   isUseCaseFilled() {
  //       return this.Account.UseCase;
  //     }
  // },
  // watch: {
  //   isUseCaseFilled(val){
  //     return this.val.trim() != '' ? true : false;
  //   }
  // },
  methods: {
    // EPE-309 -- obtain the info for the AccountView/AccountEdit object
    GetAccountValues(){
      var _this = this;
      this.isAccountLoading = true;
      axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
        .then(function (response) {
          _this.Account = response.data.raw;
          _this.ShowWufoo(_this.Account.salesforceId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    GetForm(type) {
      // this.Reset();
      // this.GetSelectValues();
      this.FormInputs = this.FieldFlags[type];
    },
    getForecastServicesToPatients() {
      axios.get(`/Account/Forecasting/${this.Account.SalesforceId}`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") }
      }).then(res => {
        this.forecastServices = res.data.raw || [];
      });
    },
    SubmitForecast() {
      this.isLoadFinish = false;
      const numberOfJobs = this.Account.PrimaryContact.OfficeLocation
        .NumberOfJobs;
      if (numberOfJobs < 100) {
        this.Account.PrimaryContact.OfficeLocation.Jobs = {
          January: null,
          February: null,
          March: null,
          April: null,
          May: null,
          June: null,
          July: null,
          August: null,
          September: null,
          October: null,
          November: null,
          December: null,
        };
      }
      const totalOfJobs = this.SaveTotalJobs(
        this.Account.PrimaryContact.OfficeLocation.Jobs
      );
      if (numberOfJobs < totalOfJobs) {
        this.Account.PrimaryContact.OfficeLocation.NumberOfJobs = totalOfJobs;
      }
      this.Account.HowDoYouPlanOnServingThosePatient = this.forecastServices;
      this.Account.toBeContactedAsVolunteer = this.toBeContactedAsVolunteer;
      // console.log(JSON.stringify(this.Account));
      axios
        .post("/Account/UpdateForecasting", this.Account)
        .then((response) => {
          if (response.data.isSuccess) {
            const targetURL = localStorage.getItem("nextURL");
            if (targetURL != null) {
              this.GetToken(targetURL);
            } else {
              this.isLoadFinish = true;
              this.showForecastingModal = true;
            }
          } else {
            this.isLoadFinish = true;
            this.OfficeLocationValidationResult =
              response.data.raw.primaryContact.officeLocation.validationResult;
          }
        })
        .catch((error) => {
          this.isLoadFinish = true;
          console.log(error);
        });
    },
    GetToken(targetURL) {
      axios
        .post("/Auth/TryRequestToken", this.Account)
        .then((response) => {
          if (response.data.isSuccess == true) {
            localStorage.setItem("token", response.data.raw.token);
            if (targetURL != null) {
              this.$router.push(targetURL);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    SaveTotalJobs(job) {
      return (
        (job.January ? parseInt(job.January) : 0) +
        (job.February ? parseInt(job.February) : 0) +
        (job.March ? parseInt(job.March) : 0) +
        (job.April ? parseInt(job.April) : 0) +
        (job.May ? parseInt(job.May) : 0) +
        (job.June ? parseInt(job.June) : 0) +
        (job.July ? parseInt(job.July) : 0) +
        (job.August ? parseInt(job.August) : 0) +
        (job.September ? parseInt(job.September) : 0) +
        (job.October ? parseInt(job.October) : 0) +
        (job.November ? parseInt(job.November) : 0) +
        (job.December ? parseInt(job.December) : 0)
      );
    }
  },
  created() {
    const accountType = localStorage.getItem("accountType");
    this.GetForm(accountType);
    this.getForecastServicesToPatients();
    this.Account.EmailAddress = localStorage.getItem("email");
    this.Account.Password = localStorage.getItem("password");
    this.Account.AccountType = accountType;
    this.Account.PrimaryContact.LegalName = localStorage.getItem("name");
    this.Account.SalesforceId = localStorage.getItem("salesforceId");
    // var this = this;
    // this.isLoadFinish = false;
    // axios.get('/Account/Self', {headers: {'Authorization': "Bearer " + localStorage.getItem("token")}})
    //   .then(function (response) {
    //     if(this.$route.params.code == null){
    //       this.isLoadFinish = true;
    //     }
    //     this.isAccountFinishLoading = true;
    //     this.Account = response.data.raw;
    //
    //
    //     this.type = this.Account.accountType === 1 ? 'Individual': this.Account.accountType === 2 ? 'Business' : 'NonProfit';
    //     this.GetForm(this.type);
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  },
};
</script>



// WEBPACK FOOTER //
// AnnualForcasting.vue?8aecbdb6